function SwiperImageText(){
  var swiper = new Swiper('.swiper-image-text', {
    slidesPerView: 3,
    spaceBetween: 12,
    navigation: {
      prevEl: '.swiper-button-prev-image-text',
      nextEl: '.swiper-button-next-image-text',
    }
  });
}

function SwiperRicette(){
  var swiper = new Swiper(".swiper-ricette", {
    slidesPerView: 1.3,
    spaceBetween: 8,
      navigation: {
        prevEl: ".swiper-button-prev-ricette",
        nextEl: ".swiper-button-next-ricette",
      },
     pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    breakpoints: {
      768: {
          spaceBetween: 16
        }
      },
    });
}

function SwiperVideo(){
  var swiper = new Swiper(".swiper-video", {
    slidesPerView: 1.3,
    spaceBetween: 8,
      navigation: {
        prevEl: ".swiper-button-prev-video",
        nextEl: ".swiper-button-next-video",
      },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    breakpoints: {
      768: {
          slidesPerView: 2.65,
          spaceBetween: 16
        },  
      991: {
          slidesPerView: 2.65
        }
      },
    });
}

function SwiperProdotti(){
  var swiper = new Swiper(".swiper-prodotti", {
    slidesPerView: 1,
    spaceBetween: 80,
      navigation: {
        prevEl: ".swiper-button-prev-prodotti",
        nextEl: ".swiper-button-next-prodotti",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
}

function SwiperProdottiSimili(){
  var swiper = new Swiper(".swiper-prodotti-simili", {
    slidesPerView: 1.3,
    spaceBetween: 8,
    autoHeight: true,
    navigation: {
      prevEl: ".swiper-button-prev-prodotti-simili",
      nextEl: ".swiper-button-next-prodotti-simili",
    },
    pagination: {
        el: ".swiper-pagination",
      },
    breakpoints: {
      768: {
          slidesPerView: 2.5,
          spaceBetween: 16
        },  
      991: {
          slidesPerView: 3.5
        }
      },
    });
}

function SwiperBlog(){
  var swiper = new Swiper(".swiper-blog", {
      navigation: {
        prevEl: ".swiper-button-prev-blog",
        nextEl: ".swiper-button-next-blog",
      },
      pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        renderFraction: function(currentClass, totalClass) {
          return '<span class="' + currentClass + '"></span> di <span class="' + totalClass + '"></span>';
        },
        }
    });
}

function SwiperRicetteSmall(){
  var swiper = new Swiper(".swiper-ricette-small", {
    slidesPerView: 1.3,
    spaceBetween: 8,
      navigation: {
        prevEl: ".swiper-button-prev-ricette-small",
        nextEl: ".swiper-button-next-ricette-small",
      },
    pagination: {
        el: ".swiper-pagination",
      },
    breakpoints: {
      768: {
          spaceBetween: 16
        },  
      991: {
          slidesPerView: 1.5
        },
      1199: {
          slidesPerView: 2.5
        }
      },
    });
}

function SwiperFullWidth(){
  var swiper = new Swiper(".swiper-full-width", {
    slidesPerView: 1.3,
    //centeredSlides: true,
    //loop: true,
    spaceBetween: 16,
      navigation: {
        prevEl: ".swiper-button-prev-full-width",
        nextEl: ".swiper-button-next-full-width",
      },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    breakpoints: {
      768: {
          slidesPerView: 2.7
        },  
      991: {
          slidesPerView: 4.7
        }
      },
    });
}

function SwiperDeafult(){
  var swiper = new Swiper(".swiper-default", {
    slidesPerView: 1,
      navigation: {
        prevEl: ".swiper-button-prev-default",
        nextEl: ".swiper-button-next-default",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
}

$(document).ready(function() {
  SwiperImageText();
  SwiperRicette(); 
  SwiperVideo();
  SwiperProdotti();
  SwiperProdottiSimili();
  SwiperBlog();
  SwiperRicetteSmall();
  SwiperFullWidth();
  SwiperDeafult();
});